import WithAuthUncheck from "./WithAuthUncheck/index";
import { compose, setDisplayName, withProps, lifecycle } from "recompose";
import SidebarLayout from "./SidebarLayout";
import WithResizeListener from "./WithResizeListener";
import { connect } from "react-redux";
import { actions } from "../modules/settings";
import uuid from "uuid/v1";
import sessionId from "../modules/sessionId";

export default compose(
  setDisplayName("Market"),
  connect(
    null,
    { setRole: actions.setRole }
  ),
  lifecycle({
    componentDidMount() {
      const { setRole } = this.props;
      setRole("anonymous");

      if (!sessionId.get()) {
        sessionId.set(uuid());
      }
    },
    componentWillUnmount() {
      this.props.setRole(null);
    }
  }),
  WithAuthUncheck,
  WithResizeListener,
  withProps(props => {
    const {
      computedMatch: {
        params: { dealer_id }
      }
    } = props;
    return {
      routes: [
        {
          name: "Login",
          path: `/`,
          icon: "pe-7s-unlock",
          roles: ["anonymous"]
        },
        {
          name: "Products",
          path: `/dealers/${dealer_id}/products`,
          icon: "pe-7s-shopbag",
          roles: ["anonymous"]
        },
        {
          name: "Shopping Cart",
          path: `/dealers/${dealer_id}/shopping-cart`,
          icon: "pe-7s-cart",
          roles: ["anonymous"]
        }
      ]
    };
  })
)(SidebarLayout);
